
(function () {
  'use strict';

  var EMBED = /(?:youtube\.com|youtu\.be|vimeo\.com|\/embed\/|player\.)/i;
  var FILE = /\.(mp4|webm|ogv|mov|m4v)(\?|#|$)/i;

  function posterUrl(box) {
    var img = box.querySelector('.vb-poster') || box.querySelector('img');
    return img ? (img.currentSrc || img.src || '') : '';
  }

  function embedUrl(src) {
    var m = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{6,})/i.exec(src);
    if (m) return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0';
    m = /vimeo\.com\/(?:video\/)?(\d+)/i.exec(src);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'autoplay=1';
  }

  function isFile(src) {
    return FILE.test(src) || !EMBED.test(src);
  }

  function auto(box) {
    return box.hasAttribute('data-video-auto') && isFile((box.getAttribute('data-video-src') || '').trim());
  }

  function make(box, src) {
    var el;
    if (isFile(src)) {
      el = document.createElement('video');
      el.src = src;
      el.playsInline = true;
      el.preload = 'auto';
      var p = posterUrl(box);
      if (p) el.poster = p;
      if (auto(box)) {
        el.controls = false;
        el.loop = true;
        el.muted = true;
        el.setAttribute('muted', '');
        el.autoplay = true;
      } else {
        el.controls = true;
        el.autoplay = true;
        el.addEventListener('ended', function () { stop(box); });
      }
    } else {
      el = document.createElement('iframe');
      el.src = embedUrl(src);
      el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      el.setAttribute('allowfullscreen', '');
      el.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      el.setAttribute('title', box.getAttribute('data-video-title') || 'Відео');
      el.setAttribute('loading', 'lazy');
    }
    el.className = 'vb-media';
    return el;
  }

  function stop(box) {
    if (!box) return;
    var m = box.querySelector('.vb-media');
    if (m) {

      try { m.removeAttribute('src'); } catch (e) {  }
      m.remove();
    }
    box.classList.remove('is-playing');
  }

  function start(box) {
    if (!box || box.classList.contains('is-playing')) return;
    var src = (box.getAttribute('data-video-src') || '').trim();
    if (!src) return;
    var media = make(box, src);
    box.appendChild(media);
    box.classList.add('is-playing');

    if (media.tagName === 'VIDEO') {
      var pr = media.play();
      if (pr && pr.catch) {
        pr.catch(function () {
          if (!auto(box)) return;

          box.removeAttribute('data-video-auto');
          stop(box);
        });
      }
    }
  }

  function watch() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var box = e.target;
        if (e.isIntersecting) { if (auto(box)) start(box); }
        else if (box.classList.contains('is-playing')) stop(box);
      });
    }, { threshold: 0.35 });

    var mo = new MutationObserver(function (recs) {
      recs.forEach(function (r) {
        var box = r.target;
        if (!box.hasAttribute('data-video-auto')) return;
        if (!auto(box)) { stop(box); return; }
        var r0 = box.getBoundingClientRect();
        var seen = r0.top < innerHeight * 0.65 && r0.bottom > innerHeight * 0.35;
        if (!seen) return;
        stop(box);
        start(box);
      });
    });

    document.querySelectorAll('.vb[data-video-auto]').forEach(function (box) {
      io.observe(box);
      mo.observe(box, { attributes: true, attributeFilter: ['data-video-src'] });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);

  document.addEventListener('click', function (e) {
    var box = e.target.closest ? e.target.closest('.vb') : null;
    if (!box) return;
    var btn = e.target.closest('button');
    if (!btn || !box.contains(btn)) return;

    if (!btn.hasAttribute('data-video-play')) return;
    e.preventDefault();
    start(box);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var box = document.querySelector('.vb.is-playing');
    if (!box) return;
    stop(box);
    var b = box.querySelector('[data-video-play]');
    if (b) b.focus();
  });

  window.saVideo = { start: start, stop: stop };
})();
